/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ImplementIdDto {
  active?: boolean;
  deleted?: boolean;
  foxId?: string;
  id?: number;
  make?: string;
  model?: string;
  name?: string;
  type1?: number;
  type2?: number;
  type3?: number;
}
